const errorMessages: { [index: string]: string } = {
  'Scheduled date is out of range': '예약일이 지났습니다. 날짜를 수정해주세요.',
  'Bulk Request is already started': '이미 대량전송 작업이 진행되었습니다.',
  'Bulk Request Not Found': '대량전송을 찾을 수 없습니다.',
  'Schedule is Already Canceled': '이미 취소된 대량전송 예약 일정입니다.',
  'Invalid scope': '이용 권한이 없습니다.',
  'Forbidden workspace': '이용 권한이 없습니다.',
  'Forbidden resource': '이용 권한이 없습니다.',
  'Forbidden authority': '사용량이 부족합니다.',
  'workspace id has not set.': '이용 권한이 없습니다.',

  // 유저
  'Forbidden role': '이용할 수 없는 역할입니다.',
  'Forbidden invitation': '볼 수 없는 초대장입니다.',
  'Forbidden member': '이용할 수 있는 권한이 없습니다.',
  'Already verified user': '이미 인증이 완료된 사용자입니다.',
  'Different id provider': '해당 이메일 주소는 다른 소셜을 통해 가입한 사용자 입니다.',
  'email not authenticated': '인증되지 않은 이메일 사용자입니다.',
  'email user not found': '해당 이메일로 가입한 사용자가 없습니다.',
  'Exceed feature usage quota': '기능 사용량이 초과되었습니다.',
  'Invalid email verification token':
    '링크의 인증 유효 기간이 만료되었습니다.\n로그인 후 재전송해 주세요.',
  'Invalid login token': '서비스 접근 권한이 없습니다. 다시 로그인 해주세요.',
  'Invalid password reset token': '유효하지 않은 비밀번호 재설정 주소입니다.',
  'Invalid password': '비밀번호가 유효하지 않습니다.',
  'Cannot change password previously used password':
    '현재 사용 중인 비밀번호와 동일한 비밀번호입니다. 다른 비밀번호로 변경해 주세요.',
  'Invalid third party profile': '유효하지 않은 소셜 정보입니다.',
  'Left user': '이미 탈퇴한 사용자입니다.',
  'Member already exists': '해당 멤버는 이미 워크스페이스에 존재합니다.',
  'Not email user': '이메일 주소로 가입한 사용자가 아닙니다.',
  'not third party user': '소셜 계정으로 가입한 사용자가 아닙니다.',
  'OAuth failed': '서비스 접근 권한이 없습니다. 다시 로그인 해주세요.',
  'Plan not found': '요금제를 찾을 수 없습니다.',
  'Seat limit exceeded': '최대 인원에 따른 초대 가능한 수를 초과했습니다.',
  'Third party user not found':
    '해당 소셜 계정으로 가입한 사용자가 아닙니다. 확인 후 다시 시도해 주세요.',
  'User already exists': '사용자가 이미 존재합니다.',
  'User authority not found': '사용자 권한을 찾을 수 없습니다.',
  'user not found': '모두싸인에 가입하지 않은 사용자입니다.',
  'User not found': '사용자를 찾을 수 없습니다.',
  'You cannot delete accepted invitation': '이미 초대를 수락해서 삭제할 수 없습니다.',
  'Forbidden permission': '권한이 없거나 찾을 수 없습니다.',
  'Invalid query params': '올바르지 않은 요청입니다.',
  'Id or email is required': '유저 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  'Deposit balance must be zero': '남아있는 예치금이 있습니다. 문의를 통해 환불해 주세요.',
  'Active bulk requests exist':
    '전송 진행 중인 대량전송이 있습니다. 작업이 완료된 후 다시 시도해 주세요.',
  'Workspace not found': '워크스페이스 정보를 불러오지 못했습니다.',
  'Member not found': '찾을 수 없는 멤버입니다.',
  'Role not found': '찾을 수 없는 역할입니다.',
  'Group not found': '찾을 수 없는 그룹입니다.',
  'Invitation not found': '찾을 수 없는 초대입니다.',
  'Automatic sharing cannot register yourself':
    '자동 공유에 자신을 포함할 수 없습니다. 수정 후 다시 시도해 주세요.',
  'Automatic sharing group not found': '존재하지 않는 그룹이 포함되어있습니다.',
  'Automatic sharing member not found': '존재하지 않는 멤버가 포함되어있습니다.',
  'Group type is not custom': '‘모든 멤버’ 그룹은 수정할 수 없습니다.',
  'Group name already exists': '이미 존재하는 그룹 이름입니다.',
  'Role name already exists': '이미 존재하는 역할 이름입니다.',
  'Workspaces are different': '다른 워크스페이스에 대한 요청은 실행할 수 없습니다.',
  'Invalid user': '올바르지 않은 유저입니다.',
  'At least one admin must exist': '최고 관리자를 찾을 수 없어 이메일을 전송할 수 없습니다.',
  'Cannot update all members group': '‘모든 멤버’ 그룹은 수정할 수 없습니다.',
  'Cannot update admin role': '최고 관리자 역할은 수정할 수 없습니다.',
  'Cannot delete admin role': '최고 관리자 역할은 삭제할 수 없습니다.',
  'Cannot grant admin role to member': '최고 관리자 역할은 다른 멤버에게 부여할 수 없습니다.',
  'Cannot remove admin role from member': '최고 관리자인 멤버에게 다른 역할을 부여할 수 없습니다.',
  'Cannot delete admin member': '최고 관리자는 삭제할 수 없습니다.',
  'Cannot delete all members group': '‘모든 멤버’ 그룹은 삭제할 수 없습니다.',
  'There are not enoguh seats': '잔여 시트가 없습니다.',
  'Invitation is not ongoing': '초대 진행 중이 아닙니다.',
  'Invitation is already deleted': '이미 초대가 삭제되었습니다.',
  'Member already has received other invitation': '이미 초대가 진행 중인 이메일입니다.',
  'Member already joined other public workspace': '이미 속한 공용 워크스페이스가 있습니다.',
  'Member already joined same public worksapce': '이미 멤버가 공용 워크스페이스에 속해있습니다.',
  'Cannot add member to all members group in manual': '모든 멤버 그룹에 멤버를 추가할 수 없습니다.',
  'Cannot remove member from all members group in manual':
    '모든 멤버 그룹에서 멤버를 제거할 수 없습니다.',
  'Workspace is not public': '개인 워크스페이스에서는 이용할 수 없습니다.',
  'Emails are different': '초대한 이메일과 다른 이메일입니다.',
  'Workspace is not private': '개인 워크스페이스만 공용 워크스페이스로 전환할 수 있습니다.',
  'Member already joined other private workspace': '이미 개인 워크스페이스가 존재합니다.',
  'Member is not admin': '최고 관리자가 아니면 이용할 수 없습니다.',
  'There are other members in workspace': '아직 남아 있는 멤버가 존재합니다.',
  'There are ongoing invitations in workspace': '아직 초대가 진행 중인 멤버가 있습니다.',
  'Member has public workspace': '아직 소속된 공용 워크스페이스가 있습니다.',
  'Role must have at least one permission': '적어도 한 개 이상의 권한 설정이 필요합니다.',
  'Number of groups has been exceeded': '그룹은 최대 500개까지만 만들 수 있습니다.',
  'Number of roles has been exceeded': '역할은 최대 500개까지 만들 수 있습니다.',
  'Number of members has been exceeded': '멤버는 최대 1,000명까지 초대할 수 있습니다.',
  'Cannot delegate workspace to admin member': '해당 멤버에게 워크스페이스를 위임할 수 없습니다.',
  'Authority exists': '요금제가 남아있습니다.',

  // 알림
  'Invalid payment notification type': '결제 알림 종류가 유효하지 않습니다.',
  'Kakaotalk channel already registered':
    '해당 카카오톡 채널은 다른 사용자가 이미 연동 중인 채널입니다. 다른 카카오톡 채널로 연동해 주세요.',
  'Kakaotalk channel not found': '해당 카카오톡 채널을 찾을 수 없습니다. 다시 시도해 주세요.',
  'Kakaotalk custom channel already activated':
    '해당 카카오톡 채널은 이미 연동된 상태입니다. 카카오톡 채널의 연동 상태를 확인하신 후, 다시 시도해 주세요.',
  'Kakaotalk custom channel already deactivated':
    '해당 카카오톡 채널은 이미 연동 해제된 상태입니다. 카카오톡 채널의 연동 상태를 확인하신 후, 다시 시도해 주세요.',
  'Kakaotalk custom channel not found':
    '해당 카카오톡 채널의 관리 정보를 찾을 수 없습니다. 다시 시도해 주세요.',
  'Payment notification not found': '결제 알림 수단을 찾을 수 없습니다.',

  // 서명
  'Cannot fetch member list': '멤버 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  'Cannot fetch group list': '그룹 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  'Session not found': '대면서명 세션이 만료되었습니다.\n창을 닫고 다시 시작해 주세요.',
  'Session is occupied by other signer': '다른 페이지에서 새로운 대면서명을 시작하였습니다.',
  'Invalid name or contact info of in person contract':
    '입력한 정보로 서명 완료한 문서가 없습니다.\n다시 입력해 주세요.',
  'Signer has already signed': '이미 서명을 완료한 문서입니다.',

  // 내부결재
  'Member is not found': '찾을 수 없는 멤버입니다.',
  'Document category is not found': '라벨 설정에 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  'Document role grant is not found':
    '공유 설정에 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  'Drafter left workspace': '기안자가 워크스페이스에 존재하지 않습니다.',
  'Member is not drafter': '기안자만 이용할 수 있는 기능입니다.',
  'Member is not reviewer': '결재자만 이용할 수 있는 기능입니다.',
  'Too many labels': '내부결재 시 서명 문서에 적용할 라벨은 최대 5개까지 설정할 수 있습니다.',

  // 라벨
  'Label not found': '찾을 수 없는 라벨입니다.',
  'Label bookmark not found': '라벨의 즐겨찾기 정보를 찾을 수 없습니다.',
  'Workspace role can only be used alone': '라벨 접근 대상 정보가 올바르지 않습니다.',
  'Workspace label role must have role name':
    '알 수 없는 오류가 발생했습니다. 고객센터로 문의바랍니다.',
  'The label is already bookmarked': '이미 즐겨찾기한 라벨입니다.',
  'Max label count exceed': '라벨은 최대 5,000개까지 만들 수 있습니다.',

  // 전송 예약 문서
  'Schedule status is not valid for cancel': '전송예약을 취소할 수 없습니다.',
  'Document status is not valid for start': '문서를 전송할 수 없습니다.',
  'Document status is not scheduled': '문서가 전송예약 상태가 아닙니다.',
  'Schedule status is not valid for update': '전송예약 시간을 수정할 수 없습니다.',

  // 문서
  'Forbidden document': '이용할 수 있는 권한이 없습니다.',
  'Converting pdf is timed out because this job takes too long':
    '문서의 PDF 변환 과정에서 오류가 발생했습니다. 오류가 반복될 경우, PDF 파일로 먼저 변환한 후 업로드해주세요. 이용에 불편을 드려 죄송합니다.',
  'Error: Export input values job already completed':
    '이미 추출이 완료되어 다운로드 링크가 메일로 전달되었습니다.',
  'Error: Export input values job already aborted': '이미 취소된 작업입니다.',
  'Document status is not on going': '서명 진행 중이 아닙니다.',
  'Abort status is invalid': '문서 상태가 올바르지 않습니다.',
  'Participant is invalid': '요청자 정보가 올바르지 않습니다.',
  'Signing is not found': '서명 정보를 찾을 수 없습니다.',
  'ChangeSigningPeriod saga is failed': '서명 만료일 변경에 실패했습니다.',
  'Document not found': '찾을 수 없는 문서입니다.',
  'Participant type is invalid': '올바르지 않은 참여자가 있습니다.',
  'Document download is not found': '문서 다운로드 요청을 찾을 수 없습니다.',
  'Document status is not completed': '문서가 완료 상태가 아닙니다.',
  'Contacts are not members of the document': '서명 참여자 정보와 달라 다운로드할 수 없습니다.',
  'Document to download does not exist': '다운로드할 문서를 찾을 수 없습니다.',
  'Can not create download task': '다운로드를 진행할 수 없습니다.',
  'Zip file extension is not valid': '문서 번들에 포함할 파일을 압축할 수 없습니다.',
  'Readable documents are not exist': '권한이 없거나 찾을 수 없는 문서입니다',

  '"locationX" must be larger than or equal to 0':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"locationX" must be less than or equal to 1':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"locationY" must be larger than or equal to 0':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"locationY" must be less than or equal to 1':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"sizeHeight" must be larger than or equal to 0.01':
    '사인/도장 입력란이 너무 작게 입력되었습니다.\n사인/도장 입력란의 크기를 키워주세요.',
  '"sizeWidth" must be larger than or equal to 0.01':
    '사인/도장 입력란이 너무 작게 입력되었습니다.\n사인/도장 입력란의 크기를 키워주세요.',
  '"textValueText" length must be less than or equal to 300 characters long':
    '텍스트는 300자 이하로 입력할 수 있습니다.',
  '"x" must be larger than or equal to 0':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"x" must be less than or equal to 1':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"y" must be larger than or equal to 0':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  '"y" must be less than or equal to 1':
    '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
  'all fields are not completed':
    '아직 입력해야 할 필수 입력란이 남아있습니다. 입력 후 시도해 주세요.',
  'all participant of current signing order haven`t signed':
    '아직 현재 순서의 모든 서명자가 서명하지 않았습니다. 잠시 기다려 주세요.',
  'attachment file not found': '첨부파일을 찾을 수 없습니다.',
  'attachments limit exceeded': '첨부파일 요청 제한 개수를 초과하였습니다.',
  'audit trail file not found': '감사추적인증서 파일을 찾을 수 없습니다.',
  'authentication exceeded': '최대 인증 실패 횟수를 초과했습니다. 잠시동안 인증이 제한됩니다.',
  'authentication not found': '인증을 찾을 수 없습니다.',
  'count limit of fields exceed':
    '최대 설정 가능한 입력란 개수를 초과했습니다. 입력란 개수를 줄여주세요.',
  'document not found': '문서를 찾을 수 없습니다.',
  'document status is not completed': '서명이 완료된 문서가 아닙니다.',
  'document status is not on going': '문서가 진행 중이 아닙니다.',
  'document status is not on processing': '문서가 처리 중이 아닙니다.',
  'Draft is not found': '초안을 찾을 수 없습니다.\n잘못된 주소이거나, 유효기간이 지난 주소입니다.',
  'editing document not found': '편집 문서를 찾을 수 없습니다.',
  'exceed feature usage quota': '기능 사용 할당량이 초과되었습니다.',
  'field not exists': '필드가 존재하지 않습니다.',
  'field not found': '입력란을 찾을 수 없습니다.',
  'Generated signature is not allowed':
    '생성한 도장은 사용할 수 없습니다.\n업로드한 도장을 사용해주세요.',
  'file format is not supported': '첨부할 수 없는 파일형식입니다.',
  'invalid authentication key': '유효하지 않은 키 접근입니다.',
  'Invalid document access token': '문서 접근 토큰이 유효하지 않습니다.',
  'invalid editing document status': '편집 문서의 상태가 유효하지 않습니다.',
  'invalid input to guide': '필드 입력 조건에 부합하지 않는 입력입니다.',
  'invalid membership expiry': '사용할 수 없는 요금제의 만료일 입니다.',
  'invalid participant': '유효하지 않은 서명자입니다.',
  'invalid requester': '유효하지 않은 요청자입니다.',
  'invalid signing order': '서명 순서가 유효하지 않습니다.',
  'membership expired': '요금제가 만료되었습니다.',
  'membership not found': '요금제를 찾을 수 없습니다.',
  'Migration is not finished yet':
    '문서 이전이 진행되고 있어요.\n조금만 더 기다린 후 다시 시도해 주세요.',
  'no ticket remains': '사용 가능한 요금제 또는 이용권이 없습니다.',
  'no usable membership exists': '사용 가능한 요금제 또는 이용권이 없습니다.',
  'Not user member': '해당 사용자가 개인 사용자가 아닙니다.',
  'participant already signed': '이미 서명한 서명자입니다.',
  'participant authentication not found': '서명자 인증을 찾을 수 없습니다.',
  'Participant authentications are not completed':
    '추가 인증 수단 및 첨부 파일이 만료되었습니다. 서명을 다시 진행해주세요.',
  'participant field not found': '서명자 입력란을 찾을 수 없습니다.',
  'participant is not current signing order': '현재 서명할 차례가 아닙니다.',
  'participant need signature field at least one':
    '모든 서명자는 최소 1개 이상의 사인/도장 입력란 설정이 필요합니다.',
  'required attachment file is not attached': '필수 첨부파일이 첨부되지 않았습니다.',
  'signing expiry time expired':
    '서명 유효 기간이 만료되었습니다. 서명 요청자에게 유효기간 변경을 요청해 주세요.',
  'signing not found': '서명을 찾을 수 없습니다.',
  'the attachment is too large': '첨부파일의 최대 크기를 초과하였습니다.',
  'the name is already used': '이미 사용 중인 이름입니다.',
  'unprocessable authentication': '진행할 수 없는 인증입니다.',
  'PDF has password': 'PDF 파일 암호가 설정되어있습니다. 암호 해제 후 다시 시도해주세요.',

  'Count limit of target documents exceeded': '최대 추출할 수 있는 문서는 5천건입니다.',
  'Target documents cannot be empty': '입력값을 추출할 수 있는 문서가 없습니다.',
  'Allowed documents cannot be empty': '입력값을 추출할 수 있는 문서가 없습니다.',

  // 사인도장
  'Requester is not a signature accessor': '이용할 수 없는 사인/도장입니다.',
  'Only admin can get histories': '멤버는 서명 이용 내역에 접근할 수 없습니다.',
  'UserId of requester and userId in query are different': '이용할 수 없는 사인/도장입니다.',
  'Signature not found': '찾을 수 없는 사인/도장입니다.',
  'Some users not found': '찾을 수 없는 멤버입니다.',
  'Invalid ownership type': '유효하지 않은 사인/도장이 있습니다.',
  'Cannot fetch user info': '이용자 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  'Cannot fetch member info': '멤버 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  'Invalid drawn sign svg code': '유효하지 않은 이미지 형식입니다.',
  'Only user signatures can be downloaded': '워크스페이스 사인/도장은 다운로드할 수 없습니다.',
  'Error occurred while processing subprocess':
    '요청된 작업 처리 중 알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  'Subprocess exit with error':
    '요청된 작업이 비정상적으로 종료되었습니다.  잠시 후 다시 시도해 주세요.',
  'Forbidden signature permission': '권한이 없거나 찾을 수 없는 사인·도장입니다.',

  // 요금제
  'Authority is not available': '서명 요청 시 요금제에 오류가 발생했습니다',
  'Authority not found': '서명 요청 시 요금제에 오류가 발생했습니다.',
  'Permission is not granted': '서명 요청 시 요금제에 오류가 발생했습니다.',
  'Usage count exceeded throttle limit': '서명 요청 시 요금제에 오류가 발생했습니다.',
  'Usage count exceeded quota limit': '서명 요청 시 요금제에 오류가 발생했습니다.',

  // 구독
  'Can not start subscription with trial plan':
    'Trial 요금제를 이용한 이력이 있어 다시 이용할 수 없습니다.',
  'Subscription is not trial plan': '알 수 없는 오류가 발생했습니다. 고객센터로 문의바랍니다.',
  'Private workspace can not be purchased':
    '공용 워크스페이스가 있으면, 개인 워크스페이스에서 요금제를 구매할 수 없습니다.',
  'Already plan changed': '이미 요금제가 변경되었습니다.',
  'Applied plan not found': '적용된 요금제를 찾을 수 없습니다.',
  'Available feature action is duplicated': '사용 가능한 기능을 중복해서 적용할 수 없습니다.',
  'Booked plan not found': '예약된 요금제를 찾을 수 없습니다.',
  'Cannot cancel inactive subscription': '진행 중이 아닌 정기결제를 중단할 수 없습니다.',
  'Cannot change subscribing plan': '정기결제 중인 요금제를 변경할 수 없습니다.',
  'Cannot start subscription with trial plan': '사용할 수 없는 트라이얼 요금제 입니다.',
  'Custom plan cannot be changed': '맞춤 요금제는 변경할 수 없습니다.',
  'End date must be after to start date': '요금제가 종료되는 날짜는 시작 날짜보다 늦어야 합니다.',
  'Invalid discount scale': '유효하지 않은 할인 금액입니다.',
  'Invalid payment method': '결제 수단이 유효하지 않습니다.',
  'Invalid plan interval': '요금제 결제 주기가 유효하지 않습니다.',
  'Invalid subscription renewal status': '정기결제 갱신 상태가 유효하지 않습니다.',
  'Invalid unit price': '단위 가격이 유효하지 않습니다.',
  'Kakao notification usage exceeded':
    '카카오톡 재전송 횟수가 소진되었습니다.\n충전 후 재시도 해주세요.',
  'Member user cannot create subscription': '멤버는 정기결제 요금제를 구매할 수 없습니다.',
  'Must include only one plan': '정기결제 시 적어도 1개의 요금제를 포함해야 합니다.',
  'Need higher grade plan': '더 높은 등급의 요금제가 필요합니다.',
  'Next payment date is not today': '결제일이 오늘이 아닙니다.',
  'Next payment schedule not exist': '다음 결제 스케줄이 없습니다.',
  'No available booked plans': '대기 중인 요금제가 없습니다.',
  'Not enough seat quantity': '시트의 수가 충분하지 않습니다.',
  'Not trial plan': '트라이얼 요금제가 아닙니다.',
  'Payment method cannot be changed': '결제 수단을 변경할 수 없습니다.',
  'Payment method not exist': '결제 수단이 없습니다.',
  'Payment method required to start subscription':
    '정기결제를 시작하기 위해서는 결제 수단이 있어야 합니다.',
  'Payment status is invalid': '결제 상태가 유효하지 않습니다.',
  'Plan not allowed to start new subscription': '정기 결제를 시작할 수 없는 요금제 입니다.',
  'Renewal date of month not exist': '갱신 일자가 없습니다.',
  'Subscription includes unsupported feature':
    '현재 정기결제가 지원하지 않는 기능을 포함하고 있습니다.',
  'Subscription is in free offer period': '업그레이드 요금제의 무료 제공 기간입니다.',
  'Subscription is not canceled': '중단되지 않은 정기결제입니다.',
  'Subscription is not recoverable': '다시 시작할 수 없는 정기결제입니다.',
  'Subscription must be active': '진행 중인 정기결제가 아닙니다.',
  'Subscription must stay at ready or failed before start':
    '정기 결제가 시작되기 전에는 Ready 또는 Failed 상태여야 합니다.',
  'Subscription must stop': '정기결제를 진행할 수 없습니다',
  'Subscription not found': '정기 결제를 찾을 수 없습니다.',
  'Subscription will be terminated soon': '정기결제가 곧 종료될 예정입니다.',
  'User authority expired': '사용자 권한이 만료되었습니다.',

  // 결제
  'Invalid discount scale type': '유효하지 않은 할인 금액입니다.',
  'Invalid payment type': '유효하지 않은 결제 방식입니다. ',
  'Not paid': '결제가 되지 않았습니다.',
  'Payment is not pending': '결제할 차례가 아닙니다.',
  'Payment not found': '결제 정보를 찾을 수 없습니다.',
  'PrimaryPaymentMethod not found': '설정된 대표 결제 수단이 없어 결제 할 수 없습니다.',
  'Refundable amount exceeded': '환불 가능한 금액이 초과되었습니다.',
  'Invalid plan status': '요금제 상태가 유효하지 않습니다.',
  'MerchantUid not found': '결제 식별 정보를 찾을 수 없습니다.',
  'Unsupported PaymentMethodType': '카드 결제가 아닌 정보를 요청했습니다.',
  'Unsupported PaymentStatus': '결제 상태가 결제 완료나 환불이 아닙니다.',
  'Receipt not found': '영수증 정보를 찾을 수 없습니다.',

  // 카드
  'Card not found': '카드를 찾을 수 없습니다.',

  // 가상 계좌
  'Amount of vbank is invalid': '가상 계좌의 입금 금액이 유효하지 않습니다.',
  'Could not process':
    '예치금 결제 처리중 오류가 발생했습니다. 새로 고침 후 다시 시도해 주시고, 계속 지속되면 고객센터로 문의바랍니다.',
  'Lack of deposit': '예치금 잔액이 부족합니다.',
  'MerchantId of vbank is invalid': 'merchantId가 유효하지 않습니다.',
  'VBank already confirmed': '가상 계좌 입금이 확인되었습니다.',
  'VBank already released': '가상 계좌를 이미 발급했습니다.',

  // 템플릿
  'Forbidden template': '이용할 수 있는 권한이 없습니다.',
  'Readable templates are not exist': '권한이 없거나 찾을 수 없는 템플릿입니다',

  // 대량전송
  'Forbidden bulk request': '권한이 없는 대량전송입니다.',
  'Document category not found': '설정한 라벨이 존재하지 않습니다.',
  'Document role grant not found': '설정한 추가 공유가 존재하지 않습니다.',
  'All participants must have at least one signature field':
    '서명자의 서명 필드가 하나 이상 있어야 합니다.',
  'Bulk request form columns not matched':
    '대량 전송 폼의 컬럼과 요청 작업 컬럼이 일치하지 않습니다.',
  'Bulk request form not found': '요청한 대량전송 양식이 없습니다.',
  'Bulk request form values required':
    '엑셀 업로드 할 때, 최소 1개 이상의 요청 작업이 있어야 합니다.',
  'Bulk request form values validation failed':
    '엑셀 양식 유효성 검사가 실패했습니다. 엑셀 양식을 다시 확인 후 업로드해주세요.',
  'Bulk request id required': '대량 전송 ID가 없습니다.',
  'Bulk request not found': '요청한 대량전송이 없습니다.',
  'Bulk request permission required': '대량전송 권한이 없습니다.',
  'Failed request task not found': '실패 된 요청 작업이 없습니다.',
  'Invalid bulk request status for cancel with failure':
    '대량 전송의 모든 요청 취소 완료를 할 수 없습니다.',
  'Invalid bulk request status for cancel': '대량 전송의 모든 요청 취소 완료를 할 수 없습니다.',
  'Invalid bulk request status for disable': 'Invalid bulk request status for disable',
  'Invalid bulk request status for done with failure': '대량 전송을 완료(Done)할 수 없습니다.',
  'Invalid bulk request status for done': '대량 전송을 완료(Done)할 수 없습니다.',
  'Invalid bulk request status for pause': '대량 전송을 일시 중단(Pause)할 수 없습니다.',
  'Invalid bulk request status for ready':
    '대량 전송의 상태를 대기(Ready)상태로 변경할 수 없습니다.',
  'Invalid bulk request status for restart': '대량 전송을 재시작(Restart)할 수 없습니다.',
  'Invalid bulk request status for retry': '실패한 작업을 재시작(Retry)할 수 없습니다.',
  'Invalid bulk request status for start canceling':
    '대량 전송의 모든 요청 취소를 시작할 수 없습니다.',
  'Invalid bulk request status for start': '대량 전송을 시작(Start)할 수 없습니다.',
  'Invalid bulk request status for terminate': '대량 전송을 종료(Terminate)할 수 없습니다.',
  'Invalid fixed participant': '템플릿의 서명자가 한 명이어야 합니다.',
  'Invalid requester input type': '템플릿 요청자 입력 타입이 유효하지 않습니다.',
  'Invalid template field type': '템플릿 필드 타입이 유효하지 않습니다.',
  'Only one target participant required': '템플릿의 서명자가 한 명이어야 합니다.',
  'Request task not found': '요청한 대량전송 태스크가 없습니다.',
  'Successful request task not found': '취소 요청할 성공 요청 작업이 없습니다.',
  'Template not found': '템플릿이 없습니다.',
  'Cannot duplicate contract info in same signing order':
    '중복된 이메일 또는 번호가 있습니다. 다른 연락처를 입력해 주세요.',

  // 작성 서식
  'Draft is already deleted': '이미 삭제된 작성서식입니다.',
  'Forbidden draft': '확인할 수 있는 권한이 없습니다.',

  // 외부문서
  'Transferred workspace id must not same': '문서 이전은 서로 다른 워크스페이스로만 가능합니다.',
  'Workspace external document not found': '외부문서가 존재하지 않습니다.',
  'Max document count in label exceeded': '라벨이 적용된 계약이 최대 개수(2,000개)를 초과합니다.',
  'No readable external documents exist': '권한이 없거나 찾을 수 없는 계약입니다',

  // workspace UnprocessableEntityException
  'Cannot delete role': '최고 관리자 역할은 삭제할 수 없습니다.',
  'Cannot update role': '최고 관리자 역할은 수정할 수 없습니다.',
  'Already same role name exists': '이미 사용 중인 이름입니다. 다른 이름으로 수정해 주세요.',
  'Owner member cannot be deleted': '최고 관리자를 삭제할 수 없습니다',
  'Cannot create role no more': '역할은 최대 500개까지 만들 수 있습니다.',
  'Cannot grant other role': '다른 역할을 부여할 수 없습니다.',
  'Cannot grant root admin role':
    '최고 관리자 역할은 워크스페이스 관리자에게만 부여할 수 있습니다.',
  'Invalid owner member':
    '워크스페이스 관리자가 아닙니다. 워크스페이스 관리자 계정으로 다시 시도해 주세요.',

  // workspaceInternalServerError
  'Invalid invitation action': '이용할 수 없는 기능입니다.',

  /// 422 UnprocessableEntityException
  'Cannot add member access': '접근 가능한 멤버에 추가할 수 없습니다.',
  'Cannot remove member access': '멤버를 차단할 수 없습니다.',
  'Document already archived': '이미 삭제된 문서입니다. 새로고침 후 다시 시도해 주세요.',
  'Document not archived':
    '삭제되지 않은 문서는 복구할 수 없습니다. 새로고침 후 다시 시도해 주세요.',
  'Document is being transferred': '문서를 이전하고 있습니다. 잠시 기다려 주세요.',

  // UnprocessableEntity,
  'Shared template cannot be copied':
    '공유받은 템플릿은 복제할 수 없습니다. 원본 템플릿을 통해 추가 공유해 주세요.',
  'Shared template cannot be updated':
    '공유받은 템플릿은 수정할 수 없습니다. 원본 템플릿을 통해 수정해 주세요.',
  'Shared template cannot be shared':
    '공유받은 템플릿은 공유할 수 없습니다. 원본 템플릿을 가진 그룹에 직접 요청해 주세요.',
  'Shared template cannot have participants':
    '공유받은 템플릿에 서명자 정보를 추가할 수 없습니다. 원본 템플릿을 통해 수정해 주세요.',
  'Shared template cannot have fields':
    '공유받은 템플릿에 입력란을 추가할 수 없습니다. 원본 템플릿을 통해 수정해 주세요.',
  'Shared template cannot have attachment requests':
    '공유받은 템플릿에 첨부파일을 추가할 수 없습니다. 원본 템플릿을 통해 수정해 주세요.',
  'Shared template cannot have requester input':
    '공유받은 템플릿에 요청자 입력란을 추가할 수 없습니다. 원본 템플릿을 통해 수정해 주세요.',
  'Field position is out of file':
    'PDF 문서에서 벗어난 곳에 입력란을 지정했습니다. 확인 후 위치를 수정해 주세요.',
  'Cannot use template': '템플릿을 사용할 수 없습니다. 새로고침 후 다시 시도해 주세요.',
  'Template is being transferred': '템플릿을 이전하고 있습니다. 잠시 기다려 주세요.',
  'Forbidden approval': '이용할 수 없는 기안입니다.',

  'Forbidden user': '이용할 수 없는 유저입니다.',
  'Approval payload is not found': '결재 요청 정보를 찾을 수 없습니다.',
  'Approval execution context is not found': '결재 실행 정보를 찾을 수 없습니다.',
  'Approval is not found': '기안을 찾을 수 없습니다.',
  'User is not found': '유저 정보를 찾을 수 없습니다.',
  'Approval payload body not found': '서명 요청 정보를 찾을 수 없습니다.',
  'Profile is required': '유저 정보가 없습니다.',
  'Approval steps are required': '결재선이 설정되지 않았습니다.',
  'User is not drafter': '기안의 기안자가 아닙니다.',
  'User is not reviewer': '기안의 결재자가 아닙니다.',
  'Cannot remove approval': '기안을 삭제할 수 없습니다.',
  'Approval is not on going': '결재 진행 중인 기안이 아닙니다.',
  'Approval is not pending': '결재 요청 전인 기안이 아닙니다.',
  'Invalid current order': '현재 결재 차례가 아닙니다.',
  'Invalid approval order': '유효하지 않은 결재 차례입니다.',
  'Approval is already started': '이미 결재 요청된 기안입니다.',
  'Approval is already canceled': '이미 결재 요청이 취소된 기안입니다.',
  'Approval is already rejected': '이미 결재 반려된 기안입니다.',
  'Approval is already approved': '이미 결재 완료된 기안입니다.',
  'Invalid approval step orders': '유효하지 않은 결재 차례입니다.',
  'Approval step is not pending': '대기 중인 결재 단계가 아닙니다.',
  'Approval step is not on going': '진행 중인 결재 단계가 아닙니다.',
  'Approval step is already started': '이미 결재 단계가 시작되었습니다.',
  'Approval step is already rejected': '이미 결재가 반려되었습니다.',
  'Approval step is already approved': '이미 결재 단계가 승인되었습니다.',
  'Invalid minimum number of approvals': '유효하지 않은 결재 간소화 정보입니다.',
  'Reviewers are duplicated': '결재선에 중복 설정된 결재자가 있습니다.',
  'Review already exists': '이미 완료된 결재 차례입니다.',
  'Too many reviewers': '결재자가 10명을 초과합니다.',
  'Approval execution context is already completed':
    '이미 결재가 완료되어 서명 요청이 진행되었습니다.',
  'Approval is already deleted': '이미 삭제된 기안입니다.',
  'Approval is not completed': '결재가 완료되지 않은 기안입니다.',
  'Approval payload body is not prepared': '서명 요청 정보를 찾을 수 없습니다.',
  'File is broken': '손상된 파일입니다.',
  'Invalid approval payload type': '유효하지 않은 결재 요청 정보 타입입니다. ',
  'Invalid approval type': '유효하지 않은 결재 타입입니다.',
  'Invalid payload type': '유효하지 않은 서명 요청 정보 타입입니다.',
  'Invalid auth type': '유효하지 않은 인증 타입입니다.',
  'Invalid field group type': '유효하지 않은 입력란 그룹 타입입니다.',
  'Invalid participant type': '유효하지 않은 서명자 타입입니다.',
  'Invalid history event': '유효하지 않은 결재 진행 정보 타입입니다.',
  'Invalid field type': '유효하지 않은 입력란 정보 타입입니다.',

  // TODO(@DevSDK): 문서 설정 정보 통합 프로젝트 안정화 이후 제거하기
  'CreateDocument saga is failed':
    '알 수 없는 오류가 발생했습니다. 새로 고침 후 다시 시도해 주시고, 계속 지속되면 고객센터로 문의바랍니다.',
  'authorization token not found': '로그인 후 이용할 수 있습니다.',
  'Bad request': '설정 내용에 오류가 있습니다.\n확인 후 다시 시도해 주세요.',
  'Endpoint request timed out':
    '요청이 기본 소요시간을 초과하여 취소되었습니다. 잠시 후 다시 시도해 주세요.',
  // FIXME(@Andy): 대소문자 구분없이 에러메시지 매핑 개선하기
  'Internal server error':
    '알 수 없는 오류가 발생했습니다. 새로 고침 후 다시 시도해 주시고, 계속 지속되면 고객센터로 문의바랍니다.',
  'Internal Server Error':
    '알 수 없는 오류가 발생했습니다. 새로 고침 후 다시 시도해 주시고, 계속 지속되면 고객센터로 문의바랍니다.',
  'Network Error':
    '네트워크 연결에 문제가 있습니다.\n네트워크가 잘 연결되었는지 확인 후 다시 시도해 주세요.',
  'not authorized': '사용 시간이 만료되어 자동 로그아웃 되었습니다. 다시 로그인해 주세요.',
  forbidden: '확인할 수 있는 권한이 없습니다.',
  Forbidden: '확인할 수 있는 권한이 없습니다.',
  Unauthorized: '사용 시간이 만료되어 자동 로그아웃 되었습니다. 다시 로그인해 주세요.',
  'This file is already used': '이미 사용 중인 파일입니다.\n새로운 파일로 다시 시도해 주세요.',
  'Entity is already updated!': '잠시 후 다시 시도해 주세요.',
  'The requested file could not be read, typically due to permission problems that have occurred after a reference to a file was acquired.':
    '파일이 수정되었거나 파일에 접근할 수 없습니다. 다시 시도해 주세요.',
  'File signature does not match with ext':
    '파일에 오류가 있어 업로드할 수 없습니다.\n파일을 다시 확인해 주세요.',
};

export default errorMessages;
